import { ConciergeBehaviorSettingsParser } from "@redotech/redo-concierge-settings-common/general";
import { object, string } from "zod";

export const generateConciergeBehavior = {
  name: "generateConciergeBehavior" as const,
  input: object({ text: string().trim().min(1).max(100_000) }),
  output: ConciergeBehaviorSettingsParser,
};
